// import React from 'react';
// import { FC, ReactNode, useEffect, useState } from "react";
// import { useLocation, Navigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { isUserLoggedIn } from '../services/apiclient';
// import { useRbac } from '../context';

// interface ProtectedRouteProps {
//   children: React.ReactNode;
//   requiredPermission?: string;
//   fallbackPath?: string;
// }

// // const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
// //   children,
// // }) => {
// //   // Temporarily return children without role checking for testing
// //   return <>{children}</>;
// // };

// // export default ProtectedRoute;


// const PageLoader: React.FC = () => {
//     return (
//         <div className="flex items-center justify-center h-screen bg-white">
//             <div className="flex flex-col items-center space-y-4">
//                 <div className="w-12 h-12 border-4 border-saffron-500 border-t-transparent rounded-full animate-spin"></div>
//                 <p className="text-saffron-600 font-medium">Loading...</p>
//             </div>
//         </div>
//     );
// };

// interface ProtectedRouteProps {
//     children: ReactNode;
// }

// const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
//     const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
//   const {  user, setUser,role } = useRbac();
    
//     const location = useLocation();

//     useEffect(() => {
//         let isMounted = true;

//         const checkAuth = async () => {
//             try {
//                 const loggedIn = await isUserLoggedIn();
//                 console.log("loggedIn:", loggedIn);
//                 if (loggedIn.status === "success" && loggedIn.isAuthenticated) {

//                     setIsAuthenticated(!!loggedIn); // Convert to boolean
//                     // setUser(loggedIn.user);
//                 }
//                 else {
//                     throw new Error("Admin shouldn't access this page");
//                 }
//             } catch (error) {
//                 setIsAuthenticated(false);
//             }
//         };

//         if (isAuthenticated === null) {
//             checkAuth();
//         }

//         return () => {
//             isMounted = false;
//         };
//     }, [location]); // Only re-run if isAuthenticated is null

//     // Handle redirects based on authentication state
//     if (isAuthenticated === null) {
//         return <PageLoader />;
//     }

//     if (!isAuthenticated) {

//         return <Navigate to="/login" state={{ from: location }} replace />;
//     }

//     return <>{children}</>;
// };

// export default ProtectedRoute;











import React, { ReactNode, useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { getCurrentUser, isUserLoggedIn } from "../services/apiclient";
import { useRbac } from "../context";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: keyof ReturnType<typeof useRbac>["user"] | string;
  fallbackPath?: string;
}

const PageLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-saffron-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-saffron-600 font-medium">Loading...</p>
      </div>
    </div>
  );
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermission,
  fallbackPath = "/unauthorized",
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const { hasPermission, setUser, user } = useRbac();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const loggedIn = await isUserLoggedIn();
        if (loggedIn.status === "success" && loggedIn.isAuthenticated) {
          setIsAuthenticated(true);
        } else {
          throw new Error("Not authenticated");
        }
      } catch {
        setIsAuthenticated(false);
      }
    };

    if (isAuthenticated === null) {
      checkAuth();
    }
  }, [location, isAuthenticated]);

  useEffect(() => {
    const getUserData = async () => {
      try {
        const response = await getCurrentUser();
        if (response.status === "success") {
          setUser(response.data.user);
        }
      } catch {
        // Keep route usable; auth check above still applies.
      } finally {
        setLoadingUser(false);
      }
    };
    getUserData();
  }, [setUser]);

  if (isAuthenticated === null || loadingUser) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission as any)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};


export default ProtectedRoute;
